export default __webpack_public_path__ + "stableDiffusion1dfc3d.png";